import { DateTime } from "luxon";

export const getAgeFromDateOfBirth = (dateOfBirth: string): string => {
  return Math.floor(DateTime.now().diff(DateTime.fromISO(dateOfBirth), "years").years).toString();
};
